import clsx from 'clsx'
import React, {FC} from 'react'
import {Link} from 'react-router-dom'
import {useLayout} from '../../../core/LayoutProvider'
import {usePageData} from '../../../core/PageData'

const DefaultTitle: FC = () => {
  const {pageTitle, pageDescription, pageBreadcrumbs} = usePageData()
  const {config} = useLayout()

  return (
    <div
      id='kt_page_title'
      data-kt-swapper='true'
      data-kt-swapper-mode='prepend'
      data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
      className='flex flex-wrap me-3 flex-col justify-center'
    >
      {/* begin::Title */}
      {pageTitle && (
        <h1 className='flex text-gray-900 font-bold text-lg my-0 flex-col justify-center'>
          {pageTitle}
          {pageDescription && config.pageTitle && config.pageTitle.description && (
            <>
              <span className='h-5 border-s border-gray-200 ms-3 mx-2'></span>
              <small className='text-gray-500 text-xs font-bold my-1 ms-1'>{pageDescription}</small>
            </>
          )}
        </h1>
      )}
      {/* end::Title */}

      {pageBreadcrumbs && pageBreadcrumbs.length > 0 && config.pageTitle?.breadCrumbs && (
        <>
          {config.pageTitle.direction === 'row' && (
            <span className='border-s border-gray-200 mx-4'></span>
          )}
          <ul className='flex flex-wrap gap-2 font-semibold text-xs my-0'>
            {Array.from(pageBreadcrumbs).map((item, index) => (
              <li
                key={`${item.path}${index}`}
                className={clsx('breadcrumb-item', {
                  'text-gray-900': !item.isSeparator && item.isActive,
                  'text-gray-500': !item.isSeparator && !item.isActive,
                })}
              >
                {!item.isSeparator ? (
                  <Link className='text-gray-500 hover:text-blue-600 transition' to={item.path}>
                    {item.title}
                  </Link>
                ) : (
                  <span className='inline-block bg-gray-200 w-1 h-0.5'></span>
                )}
              </li>
            ))}
            <li className='text-gray-900'>{pageTitle}</li>
          </ul>
        </>
      )}
    </div>
  )
}

export {DefaultTitle}
